﻿export class ComplaintCommentFile {
    complaintCommentId: number;
}